import { keepPreviousData, useQuery } from '@tanstack/react-query'

import http from '../../../lib/http'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useClientTags () {
  return useQuery({
    queryKey: [ 'client-tags' ],
    queryFn: async () => {
      return await (http.getRequest<string[]>('/admin/client-tags'))
    },
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    refetchOnMount: false
  })
}
